import Card from "@pathwright/ui/src/components/card/Card"
import CardBlock from "@pathwright/ui/src/components/card/CardBlock"
import { Card as CardT } from "@pathwright/ui/src/components/card/types"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import PropTypes from "prop-types"
import { FeatureKey } from "../../api/generated"
import FeaturePermissionsForm from "../form/FeaturePermissionsForm"
import { featureKeyPropType } from "../propTypes"
import { getFeatureInfo } from "../utils"

const ManageFeaturePermissions = ({
  card,
  featureKey
}: {
  card: CardT
  featureKey: FeatureKey
}) => {
  const { t } = useTranslate()
  const { title } = getFeatureInfo(featureKey, t)

  return (
    <Card
      card={card}
      title={t("{{ feature }} visibility", {
        feature: title
      })}
      noaction
    >
      <CardBlock paddingTop={false}>
        <FeaturePermissionsForm featureKey={featureKey} context={null} />
      </CardBlock>
    </Card>
  )
}

ManageFeaturePermissions.displayName = "ManageFeaturePermissions"

ManageFeaturePermissions.propTypes = {
  // provided by CardStack > CardStackCard
  card: PropTypes.object.isRequired,
  featureKey: featureKeyPropType
}

export default ManageFeaturePermissions
